// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7c76c3c0","453":"d855a71b","455":"c72059d4"}[chunkId] + ".chunk.js";
};